import { useEffect, useState } from "react";

export const useAfterInitialLoad = (): boolean => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const timeoutId = window.setTimeout(() => setReady(true), 1500);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return ready;
};
